import primaryButton from '../../../../primary-button';

const light = (params) => primaryButton.brandedSolid.background.default.light(params);

export default light;
